"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strOrFunc = strOrFunc;
exports.useHookedFunc = useHookedFunc;
exports.useStrOrStateFunc = useStrOrStateFunc;
var _react = require("react");
var _contexts = require("../app/contexts");
var _contexts2 = require("./contexts");

// if input is a string, just return the string. if it is a function, pass some state variables into it ...
function useStrOrStateFunc(input) {
  const storage = (0, _react.useContext)(_contexts.Storage);
  const {
    readingTimeString,
    readContentsString
  } = storage;
  const amount = (0, _react.useContext)(_contexts2.Amount);
  return strOrFunc(input, [readingTimeString, readContentsString, amount.str, storage, amount.isMonthly]);
}
function strOrFunc(input) {
  let argumentArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return typeof input === "function" ? input(...argumentArr) : input;
}
function useHookedFunc(hookName, defaultFunc, extraArgs) {
  const {
    hooks
  } = (0, _react.useContext)(_contexts.Settings);
  return typeof hooks[hookName] === "function" && typeof defaultFunc === "function" ? ev => {
    const customHookReturn = hooks[hookName](defaultFunc, extraArgs);
    if (customHookReturn !== false) defaultFunc(ev);
  } : defaultFunc;
}